<template>
  <div>
    <div v-if="this.data.ftshow" class="dialog-button">
      <el-button v-if="this.buttonid === '1'" type="primary" @click="format">原文</el-button>
      <el-button v-if="this.buttonid === '2'" type="primary" @click="formatto">解析</el-button>
      <el-button type="success" @click="doSeleSend" icon="el-icon-fa-refresh" title="format">自动换行</el-button>
    </div>
    <el-form ref="form" :model="data">
      <!-- <div class="pull-right">
        <el-button size='medium' v-if="this.buttonid === '1'" type="primary" @click="format">原文</el-button>
        <el-button size='medium' v-if="this.buttonid === '2'" type="primary" @click="formatto">解析</el-button>
        <el-button size='medium' type="success" @click="doSeleSend" icon="el-icon-fa-refresh" title="format">自动换行</el-button>
      </div> -->
      <el-input class="break" :rows="20" type="textarea" v-model="data.json"></el-input>
    </el-form>
  </div>
</template>

<script>
import perTmpApi from "../PerTmp";
export default {
  props: {
    datms: {},
    uuid: {},
    formatshow: true
  },
  data() {
    return {
      data: {
        json: null,
        ftshow:true,
      },
      buttonid: "1" // 控制显示
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.data.json = this.datms.content;
      this.data.ftshow = this.formatshow;
      if(this.data.ftshow===undefined){
        this.data.ftshow = true;
      }
    },
    doSeleSend() {
      var obj = document.getElementsByClassName("break");
      obj.style.cssText = "word-wrap: break-word;";
    },
    format() {
      perTmpApi.getMsTran(this.uuid).then(respData => {
        this.data.json = respData.content; /* alert(this.moulddata) */
      });
      this.buttonid = "2";
    },
    formatto() {
      perTmpApi.getMs(this.uuid).then(respData => {
        this.data.json = respData.content; /* alert(this.moulddata) */
      });
      this.buttonid = "1";
    }
  }
};
</script>

<style>
.divcss {
  border: 1px solid #00f;
  height: 120px;
  width: 200px;
  word-wrap: break-word;
}
</style>
